class Modal {
    constructor(readonly triggerButton: HTMLButtonElement) {
        this.mount();
    }
    private mount() {
        const foundContent = document.querySelector("#non-modal-content");

        let mainContent: HTMLDivElement;

        if (foundContent instanceof HTMLDivElement) {
            mainContent = foundContent;
            mainContent.setAttribute("aria-hidden", "true");
            mainContent.inert = true;
        }

        // Create overlay
        const overlay = document.createElement("div");
        overlay.classList.add("sa-error-modal");

        // 3) Screen reader text to announce
        const srText =
            "Something Went Wrong. Alert dialog. " +
            "An error occurred and the Student Assistant can't load correctly. " +
            "Try reopening Student Assistant in a few minutes.";

        // 4) Live region announcer for SR cross-compatibility (NOT aria-hidden, visually hidden only)
        const announcer = document.createElement("div");
        announcer.setAttribute("role", "alert");
        announcer.setAttribute("aria-atomic", "true");
        announcer.className = "sr-only";

        // Modal content container
        const modal = document.createElement("div");
        modal.className = "sa-error-modal-content";
        modal.setAttribute("role", "dialog");
        modal.tabIndex = -1;

        // Title
        const title = document.createElement("h2");
        title.textContent = "Something Went Wrong";
        title.setAttribute("aria-hidden", "true");

        const message = document.createElement("p");
        message.textContent =
            "An error occurred and the Student Assistant can't load correctly. " +
            "Try reopening Student Assistant in a few minutes.";
        message.setAttribute("aria-hidden", "true");

        // Button
        const closeButton = document.createElement("button");
        closeButton.id = "sa-error-back-button";
        closeButton.textContent = "Back to activity";
        closeButton.tabIndex = 0;

        closeButton.addEventListener("click", () => {
            document.body.removeChild(overlay);

            // Re-enable background content
            if (mainContent) {
                mainContent.removeAttribute("aria-hidden");
                mainContent.inert = false;
            }

            // retain focus to student assistant button
            this.triggerButton.focus();
        });

        // Assemble
        modal.append(title, message, closeButton);
        overlay.append(announcer, modal);
        document.body.appendChild(overlay);

        // Announce + focus sequence
        requestAnimationFrame(() => {
            // Trigger announcement for BOTH NVDA and JAWS without depending on label/desc parsing
            announcer.textContent = srText;
            // Land the user on a real control
            closeButton.focus();
        });
    }
}

export { Modal };
